import { get, post } from '../Config/config';

export const NotificationsAPI = {
    getScheduledNotifications: (markAsReadType = null) => 
        get(`/scheduled_notifications${markAsReadType ? `?mark_as_read=${markAsReadType}` : ''}`),
    markAsRead: (type, id) => 
        post('/mark-notification-read', { type, id: id }),
}
